import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Toolbar from '@material-ui/core/Toolbar'

const style = theme => ({
  container: {
    display: 'flex'
  },
  label: {
    flex: 1,
    paddingRight: '15px'
  },
  value: {
    marginLeft: 'auto'
  },
  icon: {
    paddingRight: '20px'
  }
})

const ItemSummary = ({ classes, title, value, label}) => {
  return (
    <Toolbar className={classes.container}>
      <div className={classes.label}>
        <Typography variant="caption">
          {title}
        </Typography>
      </div>
      <div className={classes.value}>
        <Typography variant="body1">
          {value}
        </Typography>
      </div>
    </Toolbar>
  )
}

export default withStyles(style)(ItemSummary)



// WEBPACK FOOTER //
// ./src/components/ItemSummary.js